export const ENRICHMENT_PLATFORM_ACCESS = 'data-enrichment-platform-access';
export const ENRICHMENT_UNLIMITED_USAGE = 'data-enrichment-unlimited-usage';